import { createSlice, createAsyncThunk, createAction, current } from '@reduxjs/toolkit';
import proposalGateway from '../../../../config/service';
import serviceEndpoints from '../../../../config/serviceEndpoints';

export const resetmsg = createAction('resetmsg');

export const resetPwd = createAsyncThunk('auth/resetPwd', async (data, { rejectWithValue }) => {
    const body = { ...data };
    try {
        const response = await proposalGateway.post(serviceEndpoints.reset, body);
        const { success, message } = response.data;
        if (success) {
            return response?.data;
        }

        return rejectWithValue(message);
    } catch (error) {
        return error.message;
    }
});

const slice = createSlice({
    name: 'resetPassword',
    initialState: {
        resMsg: '',
        isLoading: false,
        isReset: false,
    },

    extraReducers: (builder) => {
        builder
            .addCase(resetPwd.pending, (state) => {
                state.isLoading = true;
                state.resMsg = '';
                state.isReset = false;
            })
            .addCase(resetPwd.rejected, (state, { payload }) => {
                state.isLoading = false;
                state.resMsg = payload;
                state.isReset = false;
            })
            .addCase(resetPwd.fulfilled, (state, { payload }) => {
                const { success, message } = payload;

                state.isLoading = false;
                state.resMsg = message;
                state.isReset = success;
            })
            .addCase('resetmsg', (state) => {
                state.isLoading = current(state).isLoading;
                state.isReset = current(state).isReset;
                state.resMsg = '';
            });
    },
});

export default slice.reducer;
